// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slick-slider {
  margin: 0 auto;
}
@media only screen and (min-width: 1300px) {
  .slick-slider {
    max-width: 1013px;
  }
}

.sliderContainer {
  width: 100%;
  height: 100%;
}

.slide {
  height: 540px;
  width: 90%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slide .slick-prev, .slide .slick-next {
  position: absolute;
  top: 50%;
  z-index: 1;
}

.slick-prev:before,
.slick-next:before {
  color: black;
  width: 50px;
  height: 50%;
}

.slider--image {
  border-radius: 5px;
  width: 100%;
  height: 100%;
}

.slick-list {
  border-radius: 5px;
}

.ourwork {
  display: flex;
  justify-content: center;
  padding: 5em 0em 0em 0em;
  font-size: 30px;
}

@media (max-width: 425px) {
  .ourwork {
    margin-right: -460px;
  }

  .carouselDiv {
    width: 100%;
  }

  .sliderDiv {
    margin-right: -460px;
  }

  .slick-slider {
    right: -85px;
    width: 192%;
    padding-top: 0em;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/OurWork.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EAHF;IAIG,iBAAA;EAED;AACF;;AACC;EACC,WAAA;EACA,YAAA;AAEF;;AAAC;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACC,iBAAA;EACA,kBAAA;AAGF;AADE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAGJ;;AAGA;;EAEE,YAAA;EACA,WAAA;EACA,WAAA;AAAF;;AAGC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAIC;EACC,kBAAA;AADF;;AAGE;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;AAAJ;;AAKE;EACE;IACE,oBAAA;EAFJ;;EAME;IACE,WAAA;EAHJ;;EAME;IACE,oBAAA;EAHJ;;EAOE;IACE,YAAA;IACA,WAAA;IACA,gBAAA;EAJJ;AACF","sourcesContent":[".slick-slider {\n  margin: 0 auto;\n \n  @media only screen and (min-width: 1300px){\n   max-width: 1013px;\n  }\n }\n \n .sliderContainer {\n  width: 100%;\n  height: 100%;\n }\n .slide {\n height: 540px;\n width:90%;\n display: block;\n  margin-left: auto;\n  margin-right: auto;\n\n  .slick-prev, .slick-next {\n    position: absolute;\n    top: 50%;\n    z-index: 1;\n\n  }\n\n }\n\n.slick-prev:before,\n.slick-next:before{\n  color: black;\n  width: 50px;\n  height: 50%;\n}\n \n .slider--image {\n  border-radius: 5px;\n  width: 100%;\n  height: 100%;\n \n }\n \n .slick-list {\n  border-radius: 5px;\n }\n  .ourwork{\n    display: flex;\n    justify-content: center;\n    padding: 5em 0em 0em 0em;\n    font-size: 30px\n\n  }\n\n\n  @media (max-width: 425px){\n    .ourwork{\n      margin-right:-460px;\n    }\n \n \n    .carouselDiv{\n      width: 100%;\n    }\n\n    .sliderDiv{\n      margin-right: -460px;\n    }\n \n \n    .slick-slider{\n      right: -85px;\n      width: 192%;\n      padding-top: 0em;\n    }\n  }\n\n  \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
